import { get } from '@/app/core/request';
import publicTransportTicketRoutes from '../api-routes/public-transport-ticket-routes';

class PublicTransportTicketApi {
  async getTicket(communeId: number, customerUUID: string): Promise<string> {
    return get<string>(publicTransportTicketRoutes.ticket(communeId, customerUUID));
  }
}

export default new PublicTransportTicketApi();
